import {
  CategoryFragment,
  CompetencyFragment,
  EditTrainingTrainingFragment,
  ProcessFragment,
} from 'generated/resources/graphql'

import { BasicInfo } from './BasicInfo'
import { CompletionConfiguration } from './CompletionConfiguration'
import { InternalInfo } from './InternalInfo'
import { Relatorio } from './Relatorio'
import { AvailableSections } from './editionOptions'

export function ConfigurationComponent({
  categories,
  competencies,
  processes,
  saved = false,
  selected,
  training,
}: {
  categories: CategoryFragment[]
  competencies: CompetencyFragment[]
  processes: ProcessFragment[]
  saved?: boolean
  selected: string
  training: EditTrainingTrainingFragment
}) {
  switch (selected) {
    case AvailableSections.internal_information:
      return (
        <InternalInfo
          categories={categories}
          processes={processes}
          saved={saved}
          training={training}
        />
      )
    case AvailableSections.completion_configuration:
      return <CompletionConfiguration saved={saved} training={training} />
    case AvailableSections.relatorio:
      return (
        <Relatorio
          saved={saved}
          training={training}
          trainingRelatorioUnicoField={training.relatorioUnicoField}
        />
      )
    default:
      return <BasicInfo competencies={competencies} saved={saved} training={training} />
  }
}
